/** Empty / missing venue legal text → localized fallback, never a loading spinner. */
export function resolveLegalModalContent(text: string | undefined | null, emptyFallback: string): string {
    if (text == null || !text.trim()) {
        return emptyFallback;
    }
    return text;
}
